import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function CookieNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("ri-notice-ack")) setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div data-testid="cookie-notice" className="fixed inset-x-0 bottom-0 z-50 border-t border-[#E4E7EC] bg-white/97 shadow-[0_-4px_24px_rgba(31,45,78,0.08)] backdrop-blur">
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-4 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <p className="text-sm leading-relaxed text-[#5A6B8C]">
          This site uses privacy-respecting analytics to understand how it is used. No advertising trackers.
          See our <Link to="/privacy" className="font-medium text-[#B08D3F] underline underline-offset-2">Privacy Policy</Link>.
        </p>
        <button
          data-testid="cookie-notice-accept"
          onClick={() => { localStorage.setItem("ri-notice-ack", "1"); setShow(false); }}
          className="shrink-0 bg-[#1F2D4E] px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#B08D3F]"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
